export const ExceptionsAndOpportunity = {
  Postcode: 1,
  Duty: 2,
  Service: 3,
  Opportunity: 4,
};

export const RouteStatus = {
  Open: 2,
  Ready: 1,
  Downloaded: 6,
  InBuild: 13,
  Loading: 7,
  Departed: 9,
};

export const StopType = {
  TenThirty: 3,
  Twelve: 4,
  Evening: 8,
};

export const DriverRequests = {
  Requests: 1,
};

export const LoadTime = {
  OnSchedule: 1,
  BehindSchedule: 2,
  ScanTimeExceeded: 3,
};
